
import React, { useState, useEffect } from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import {
  Box,
  Grid,
  List,
  ListItem,
  Stack,
  Typography,
  Link as MUILink,
} from '@mui/material';
import { LocalGasStation } from '@mui/icons-material';
import FacebookIcon from '@mui/icons-material/Facebook';
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import InstagramIcon from '@mui/icons-material/Instagram';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MenuIcon from '@mui/icons-material/Menu';

// import logo from '../../assets/centrum_assets/design/index/LOGO.png';
import logo_white from '../../assets/centrum_assets/design/index/LOGO.png';
import upper_left from '../../assets/centrum_assets/design/index/upperLeft.png';
import franchise_bg from '../../assets/centrum_assets/design/index/co-ownership.png';

const Header = ({ type }) => {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openMobileSubMenu, setOpenMobileSubMenu] = useState({
    about: false,
    solutions: false,
  });
  const navigate = useNavigate();
  const toggleMobileMenu = () => setMobileOpen(!mobileOpen);
  const toggleSubMenu = (menu) => {
    setOpenMobileSubMenu((prev) => ({
      ...prev,
      [menu]: !prev[menu],
    }));
  };
  
  
  useEffect(() => {
    if (mobileOpen) {
      setMobileOpen(false);
      setOpenMobileSubMenu({ about: false, solutions: false });
    }
  }, [location.pathname]);

  const isAboutActive = () => {
    const path = location.pathname.toLowerCase();
    return (
      path === '/about' ||
      path === '/milestone' ||
      path.startsWith('/news') ||
      path.startsWith('/about/') 
    );
  };

  const isStationsActive =
    location.pathname.toLowerCase().startsWith("/stations") ||
    location.pathname.toLowerCase().includes("/station") || 
    location.pathname.toLowerCase().includes("station");
  // Parent-active logic for SOLUTIONS
  // const isSolutionsActive = () => ['/Solutions', '/Solutions/Products'].includes(location.pathname);
  const isSolutionsActive = () => {
  const path = location.pathname.toLowerCase();
  return (
    path.startsWith("/solutions") ||
    path.startsWith("/product/solutions") ||
    path.startsWith("/products")
  );
};

  const getMobileLinkStyles = (isActive) => ({
    padding: '4px 0',
    borderBottom: isActive ? '2px solid #7ac142' : '2px solid transparent',
    color: isActive ? '#7ac142' : '#000',
    transition: '0.3s',
    cursor: 'pointer',
  });

  const getMobileLinkHoverProps = (isActive) => ({
    onMouseEnter: e => {
      if (!isActive) {
        e.currentTarget.style.color = '#00b5e2';
        e.currentTarget.style.borderBottom = '2px solid #00b5e2';
      }
    },
    onMouseLeave: e => {
      if (!isActive) {
        e.currentTarget.style.color = '#000';
        e.currentTarget.style.borderBottom = '2px solid transparent';
      }
    },
  });

  return (
     <Box
      className={`navigation ${type}`}
      sx={{ position: 'sticky', top: 0, width: '100%', zIndex: 999, bgcolor: '#fff', height: { xs: '50px', sm: '65px', md: '80px', lg: '115px', xl: 'auto' } }}
    >
      {/* Desktop Header Content */}
      <Box sx={{ width: '100%', position: 'sticky', top: 0, bgcolor: '#f8f7f7ff' }}>
        <Box className="navigation-inner" sx={{ display: 'flex', width: '100%', height: { xs: '50px', sm: '65px', md: '80px', lg: '115px', xl: 'auto' } }}>
          
          {/* Logo Section */}
          <Box className="navigation-logo" sx={{ '@media (max-width:1400px)': { width: '100%' }, display: 'flex', position: 'relative', height: '100%' }}>
            <img src={upper_left} alt="" style={{ maxWidth: '100%' }} />
            {type === 'navigation-1' && (
              <MUILink component={Link} to="/" sx={{ position: 'absolute', top: '50%', left: { xs: '0%', sm: '11.5%', md: '11%', lg: '12%', xl: '50%' }, transform: { xs: 'translate(-20%, -50%)', sm: 'translate(-50%, -50%)' }, '@media (min-width: 1401px) and (max-width: 1535px)': { transform: 'translate(10%, -50%)' }, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Box component="img" src={logo_white} alt="logo" 
                sx={{ width: '100%', height: 'auto', transform: { xs: 'scale(0.50)', sm: 'scale(0.65)', md: 'scale(0.8)', lg: 'scale(1)', xl: 'scale(1.15)' }, transition: 'transform 0.3s' }} />
              </MUILink>
            )}

            {/* Hamburger Icon */}
            <Box
              sx={{
                display: 'none',
                '@media (max-width:1400px)': { display: 'flex' },
                position: 'absolute', right: 20, top: '50%', transform: 'translateY(-50%)',
                cursor: 'pointer',
              }}
              onClick={toggleMobileMenu}
            >
              <MenuIcon sx={{ fontSize: 30, color: 'gray' }} />
            </Box>
          </Box>
          {/* Left logo container */}
 

          {/* Right side */}
          <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column',  '@media (max-width:1400px)': { display: 'none'}}}>
            {/* Contact bar */}
            <Box
              sx={{
                height: 45,
                display: 'flex',
                '@media (max-width:1150px)': {
                  display: 'none',
                },
              }}
            >
              <Grid container sx={{ alignItems: 'center', width: '100%', flexWrap: 'nowrap', p: 0, m: 0 }}>
                <Grid item xs sx={{ minWidth: 0, flexGrow: 1, overflow: 'hidden', display: 'flex', }}>
                  <Grid
                    container
                    sx={{ alignItems: 'center', gap: 2, minWidth: 0, flexWrap: 'nowrap', overflow: 'hidden',  ml: 10,'@media (max-width:1300px)': {ml: 'auto',}, }}
                  >
                    {/* Phone */}
                    <Grid item sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0, flexShrink: 1,  }}>
                      <PhoneIcon sx={{ color: '#7ac142', fontSize: 20 }} />
                      <Typography
                        variant='h5'
                        noWrap
                        sx={{ color: '#646464', fontWeight: 480, overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0, flexShrink: 1,  }}
                      >
                        +63 75-653-0008
                      </Typography>
                    </Grid>
                    <Box sx={{ width: '1px', height: 20, bgcolor: '#dcdcdc', display: { xs: 'none', md: 'flex' } }} />

                    {/* Email */}
                    <Grid item sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0, flexShrink: 1,  }}>
                      <EmailIcon sx={{ color: '#7ac142', fontSize: 20 }} />
                      <Typography
                        variant='h5'
                        noWrap
                        sx={{ color: '#646464', fontWeight: 480, overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0, flexShrink: 1,  }}
                      >
                        marketing@centrumfuel.com
                      </Typography>
                    </Grid>

                    <Box sx={{ width: '1px', height: 20, bgcolor: '#dcdcdc', display: { xs: 'none', md: 'flex' } }} />

                    {/* Location */}
                    <Grid item sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0, flexShrink: 1,  }}>
                      <LocationOnIcon sx={{ color: '#7ac142', fontSize: 20 }} />
                      <Typography
                        variant='h5'
                        noWrap
                        sx={{ color: '#646464', fontWeight: 480, overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0, flexShrink: 1,  }}
                      >
                        San Miguel, Calasiao, Pangasinan
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                {/* Find Station */}
                 <Grid
                  item
                  component={NavLink}
                  to="/finder"
                  className={({ isActive }) => (isActive ? 'active' : '')}
                  sx={{
                    flexShrink: 0,
                    whiteSpace: 'nowrap',
                    pl: 2,
                    pr: 2,
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    textDecoration: 'none',
                    color: 'inherit',
                    '&.active': {
                      color: '#7ac142',
                    },
                  }}
                >
                  <Grid container justifyContent="center" alignItems="center" gap={1} sx={{ whiteSpace: 'nowrap', flexShrink: 0 }}>
                    <LocalGasStation sx={{ fontSize: '15pt', color: 'inherit' }} />
                    <Typography variant='h5' noWrap sx={{ fontWeight: 600, mr: { xl: 7, lg: 0, md: 0 }, color: 'inherit',  }}>
                      FIND A STATION
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
            <Box sx={{ width: '100%', height: '1px', bgcolor: '#e0e0e0' }} />

            {/* Main Menu */}
            <Box sx={{display: 'flex', '@media (max-width:1400px)': { display: 'none'}, flexGrow: 1 }}>
              {/* Desktop Menu */}
              <Box
                className="navigation-menu"
                sx={{ flexGrow: 1, mx: '5%', mt: { lg: 1.5 },  }}
              >
                <List
                  className="parent"
                  component={Stack}
                  sx={{
                    flexDirection: 'row',
                    '& li': { listStyle: 'none', position: 'relative', px: 2 },
                    '& a > span': {
                      fontSize: '1.5rem',
                      fontWeight: 600,
                      color: '#2c4964',
                      transition: '0.3s',
                      borderBottom: '3px solid transparent',
                      pb: 0.5,
                    },
                    '& a:hover > span': { color: '#00b5e2', borderBottom: '3px solid #00b5e2' },
                    '& a.active > span': { color: '#7ac142', borderBottom: '3px solid #7ac142' },
                  }}
                >
                  {/* HOME (Dekstop) */}
                  <ListItem>
                    <NavLink to="/" className={({ isActive }) => (isActive ? 'active' : '')}>
                      <span>HOME</span>
                    </NavLink>
                  </ListItem>

                  {/* ABOUT (Desktop) */}
                  <ListItem sx={{ '&:hover .child': { opacity: 1, visibility: 'visible', top: '4rem' } }}>
                    <NavLink to="/about" className={isAboutActive() ? 'active' : ''}>
                      <span>ABOUT</span>
                    </NavLink>
                    <Box
                      className="child"
                      sx={{
                        position: 'absolute',
                        top: '5rem',
                        left: 0,
                        opacity: 0,
                        visibility: 'hidden',
                        transition: '.3s',
                        minWidth: '20rem',
                        bgcolor: '#fff',
                        boxShadow: '0px 4px 15px rgba(0,0,0,0.12)',
                      }}
                    >
                      {/* About Children*/}
                      <List sx={{ '& a > span': { fontWeight: 500, fontSize: '1.4rem' } }}>
                        <ListItem>
                          <Link to="/about">
                            <span>About Centrum</span>
                          </Link>
                        </ListItem>
                        <ListItem>
                          <Link to="/milestone">
                            <span>Milestone</span>
                          </Link>
                        </ListItem>
                        <ListItem>
                          <Link to="/News">
                            <span>News</span>
                          </Link>
                        </ListItem>
                      </List>
                    </Box>
                  </ListItem>

                  {/* STATIONS (Desktop) */}
                  <ListItem>
                    <NavLink 
                      to="/stations" 
                      className={isStationsActive ? 'active' : ''}
                    >
                      <span>STATIONS</span>
                    </NavLink>
                  </ListItem>

                  {/* SOLUTIONS (Desktop) */}
                  <ListItem sx={{ '&:hover .child': { opacity: 1, visibility: 'visible', top: '4rem' } }}>
                    <NavLink to="/solutions" className={isSolutionsActive() ? 'active' : ''}>
                      <span>SOLUTIONS</span>
                    </NavLink>
                    <Box
                      className="child"
                      sx={{
                        position: 'absolute',
                        top: '5rem',
                        left: 0,
                        opacity: 0,
                        visibility: 'hidden',
                        transition: '.3s',
                        minWidth: '20rem',
                        bgcolor: '#fff',
                        boxShadow: '0px 4px 15px rgba(0,0,0,0.12)',
                      }}
                    >
                      {/* Solution Child */}
                      <List sx={{ '& a > span': { fontWeight: 500, fontSize: '1.4rem' } }}>
                        <ListItem>
                          <Link to="/solutions">
                            <span>Products</span>
                          </Link>
                        </ListItem>
                      </List>
                    </Box>
                  </ListItem>

                  {/* CONTACT US (Desktop) */}
                  <ListItem>
                    <NavLink to="/contact" className={({ isActive }) => (isActive ? 'active' : '')}>
                      <span style={{ whiteSpace: 'nowrap' }}>CONTACT US</span>
                    </NavLink>
                  </ListItem>
                   {/* BENEFITS (Desktop) */}
                  <ListItem>
                    <NavLink to="/benefits" className={({ isActive }) => (isActive ? 'active' : '')}>
                      <span>BENEFITS</span>
                    </NavLink>
                  </ListItem>

                  {/* Social icons */}
                  <ListItem sx={{ display: { xs: 'none', md: 'none', lg: 'block' } }}>
                    <Box display="flex" gap={2}>
                      <Link to="https://www.facebook.com/centrumfuel" target="_blank">
                        <FacebookOutlinedIcon sx={{ fontSize: 30, color: '#00b5e2' }} />
                      </Link>
                      <Link to="https://www.instagram.com/centrumfuelphil/" target="_blank" rel="noopener noreferrer">
                        <InstagramIcon sx={{fontSize: 30, fill: "url(#instagramGradient)",}}/>
                        <svg width="0" height="0">
                          <linearGradient id="instagramGradient" gradientTransform="rotate(45)">
                            <stop offset="0%" stopColor="#833AB4" /> 
                            <stop offset="30%" stopColor="#C13584" />
                            <stop offset="60%" stopColor="#FD1D1D" />
                            <stop offset="100%" stopColor="#F58529" /> 
                          </linearGradient>
                        </svg>
                      </Link>
                    </Box>
                  </ListItem>
                </List>
              </Box>

              {/* Franchise Button */}
              <Box sx={{display: 'flex', '@media (max-width:1400px)': { display: 'none'},}}>
                <Link className="franchise_button" to="/franchise">
                  <div className="flex flex-row relative h-100">
                    <img src={franchise_bg} alt="" />
                    <p
                      className="m-0"
                      style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        maxWidth: '100%',
                        maxHeight: '100%',
                        color: '#fff',
                        fontWeight: 700,
                        letterSpacing: 2
                      }}
                    >
                      FRANCHISE
                    </p>
                  </div>
                </Link>
              </Box>
              </Box>

             
            
          </Box>
        </Box>
      </Box>
      {/* Mobile Menu */}
      {mobileOpen && (
        <>
          {/* Close Button */}
          <Box
            sx={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              zIndex: 100000,
              bgcolor: 'rgba(27, 47, 65, 0.85)',
              padding: '14px 0',
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
            }}
          >
            <span
              onClick={toggleMobileMenu}
              style={{
                fontSize: '15px',
                fontWeight: 'bold',
                cursor: 'pointer',
                padding: '8px 14px',
                borderRadius: '50%',
                color: 'white',
              }}
            >
              ✕
            </span>
          </Box>

          {/* Mobile Menu List */}
          <Box
            sx={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100vh',
              bgcolor: '#fff',
              mt: 6,
              zIndex: 99999,
              overflowY: 'auto',
              p: 5,
            }}
          >
            <Stack spacing={3}>

              {/* HOME */}
              <NavLink
                to="/"
                onClick={toggleMobileMenu}
                style={({ isActive }) => ({ textDecoration: 'none' })}
              >
                {({ isActive }) => (
                  <h6
                    style={getMobileLinkStyles(isActive)}
                    {...getMobileLinkHoverProps(isActive)}
                  >
                    HOME
                  </h6>
                )}
              </NavLink>

              {/* ABOUT (Mobile) */}
              <Box>
                <NavLink
                  to="/about"
                  onClick={(e) => {
                    if (openMobileSubMenu.about || location.pathname.toLowerCase() === '/about') {
                      toggleMobileMenu();
                    } else {
                      e.preventDefault(); 
                    }
                    toggleSubMenu('about');
                  }}
                  style={{ textDecoration: 'none' }}
                >
                  <h6
                    style={getMobileLinkStyles(isAboutActive())}
                    {...getMobileLinkHoverProps(isAboutActive())}
                  >
                    ABOUT
                  </h6>
                </NavLink>

                {openMobileSubMenu.about && (
                  <Box sx={{ p: 1, bgcolor: '#fff', boxShadow: '0px 4px 15px rgba(0,0,0,0.12)' }}>
                    <List>
                      {[
                        { label: 'About Centrum', path: '/about' },
                        { label: 'Milestone', path: '/milestone' },
                        { label: 'News', path: '/news' },
                      ].map(link => (
                        <ListItem sx={{ p: 0 }} key={link.path}>
                          <Link to={link.path} onClick={toggleMobileMenu} style={{ textDecoration: 'none' }}>
                            <span
                              style={{
                                display: 'block',
                                padding: '8px 16px',
                                transition: '0.3s',
                                color: '#000',
                                fontWeight: 500,
                              }}
                              onMouseEnter={e => (e.target.style.color = '#00b5e2')}
                              onMouseLeave={e => (e.target.style.color = '#000')}
                            >
                              {link.label}
                            </span>
                          </Link>
                        </ListItem>
                      ))}
                    </List>
                  </Box>
                )}
              </Box>

              {/* STATIONS (Mobile)  */}
              <NavLink
                to="/stations"
                onClick={toggleMobileMenu}
                style={{ textDecoration: 'none' }}
              >
                <h6
                  style={getMobileLinkStyles(isStationsActive)}
                  {...getMobileLinkHoverProps(isStationsActive)}
                >
                  STATIONS
                </h6>
              </NavLink>

              {/* SOLUTIONS */}
              <Box>
                <h6
                  onClick={() => toggleSubMenu('solutions')}
                  style={getMobileLinkStyles(isSolutionsActive())}
                  {...getMobileLinkHoverProps(isSolutionsActive())}
                >
                  SOLUTIONS
                </h6>

                {openMobileSubMenu.solutions && (
                  <Box sx={{ p: 1, bgcolor: '#fff', boxShadow: '0px 4px 15px rgba(0,0,0,0.12)', borderRadius: 1 }}>
                    <List>
                      <ListItem sx={{ p: 0 }}>
                        <Link to="/solutions" onClick={toggleMobileMenu} style={{ textDecoration: 'none' }}>
                          <span
                            style={{ display: 'block', padding: '8px 16px', borderRadius: 4, transition: '0.3s', color: '#000' }}
                            onMouseEnter={e => (e.target.style.color = '#00b5e2')}
                            onMouseLeave={e => (e.target.style.color = '#000')}
                          >
                            Products
                          </span>
                        </Link>
                      </ListItem>
                    </List>
                  </Box>
                )}
              </Box>

              {/* CONTACT US */}
              <NavLink
                to="/contact"
                onClick={toggleMobileMenu}
                style={({ isActive }) => ({ textDecoration: 'none' })}
              >
                {({ isActive }) => (
                  <h6
                    style={getMobileLinkStyles(isActive)}
                    {...getMobileLinkHoverProps(isActive)}
                  >
                    CONTACT US
                  </h6>
                )}
              </NavLink>

              {/* BENEFITS */}
              <NavLink
                to="/benefits"
                onClick={toggleMobileMenu}
                style={({ isActive }) => ({ textDecoration: 'none' })}
              >
                {({ isActive }) => (
                  <h6
                    style={getMobileLinkStyles(isActive)}
                    {...getMobileLinkHoverProps(isActive)}
                  >
                    BENEFITS
                  </h6>
                )}
              </NavLink>

              {/* FIND A STATION */}
              <NavLink
                to="/finder"
                onClick={toggleMobileMenu}
                style={({ isActive }) => ({ textDecoration: 'none' })}
              >
                {({ isActive }) => (
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      cursor: 'pointer',
                      padding: '4px 0',
                      borderBottom: isActive ? '2px solid #7ac142' : '2px solid transparent',
                      color: isActive ? '#7ac142' : '#000',
                      transition: '0.3s',
                    }}
                    onMouseEnter={e => {
                      if (!isActive) {
                        e.currentTarget.style.color = '#00b5e2';
                        e.currentTarget.style.borderBottom = '2px solid #00b5e2';
                      }
                    }}
                    onMouseLeave={e => {
                      if (!isActive) {
                        e.currentTarget.style.color = '#000';
                        e.currentTarget.style.borderBottom = '2px solid transparent';
                      }
                    }}
                  >
                    <LocalGasStation sx={{ fontSize: '15pt' }} />
                    <h6 >FIND A STATION</h6>
                  </Box>
                )}
              </NavLink>


              {/* Social Icons */}
              <Box sx={{ display: 'flex', gap: 3, mt: 4, }}>
                <Link to="https://www.facebook.com/centrumfuel" target="_blank" style={{ textDecoration: 'none' }}>
                  <Box
                    sx={{
                      display: 'inline-block',
                      borderBottom: '2px solid transparent',
                      transition: '0.3s',
                      '&:hover': {
                        borderBottom: '2px solid #00b5e2',
                      },
                    }}
                  >
                    <FacebookOutlinedIcon sx={{ fontSize: 30, color: '#00b5e2' }} />
                  </Box>
                </Link>
                <Link to="https://www.instagram.com/centrumfuelphil/" target="_blank" style={{ textDecoration: 'none' }}>
                  <Box
                    sx={{
                      display: 'inline-block',
                      borderBottom: '2px solid transparent',
                      transition: '0.3s',
                      '&:hover': {
                        borderBottom: '2px solid #00b5e2',
                      },
                    }}
                  >
                    <InstagramIcon sx={{ fontSize: 30, color: '#E1306C' }} />
                  </Box>
                </Link>
              </Box>

              {/* FRANCHISE BUTTON */}
              <Box sx={{ mt: 5 }}>
                <Link className="franchise_button" to="/franchise" style={{ position: 'relative', display: 'inline-block', marginLeft: '-20px' }}>
                  <img src={franchise_bg} alt="" style={{ display: 'block', width: '100%', }} />
                  <p
                    style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      maxWidth: '100%',
                      maxHeight: '100%',
                      color: '#fff',
                      letterSpacing: 2,
                      fontWeight: 'bold',
                      pointerEvents: 'none',
                    }}
                  >
                    FRANCHISE
                  </p>
                </Link>
              </Box>
            </Stack>
          </Box>
        </>
      )}
    </Box>
  );
};

export default Header;